var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("reminder-auto-list", {
    attrs: {
      reminders: _vm.reminders,
      "selected-reminders": _vm.selectedReminders,
    },
    on: {
      close: function ($event) {
        return _vm.close()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }